module.exports = __webpack_public_path__ + "img/78fd232.jpg";